// extracted by mini-css-extract-plugin
export default {"root":"organisation-area-settings-popover-content_root__33IyJ"};